module.exports = __webpack_public_path__ + "img/automated-construction.8e2fffc1.png";